export const CONTINENTS = {
  'africa': 'Africa',
  'americaNord': 'North America',
  'americaSud': 'South America',
  'asia': 'Asia',
  'europe': 'Europe',
  'oceania': 'Oceania'
};
